import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  constructor() { }
 
  role_id:string="";

  ngOnInit() {
    const userData=JSON.parse(localStorage.getItem('currentUser'));
    
    if(userData){
      this.role_id=userData.role_id;
    }
  }

}
